import React, { useState } from 'react'
import Header from '../Header/Header';

// Google Apps Script Web App URL (Deploy → Web app → copy URL ending in /exec)
const GOOGLE_SHEET_URL = 'https://script.google.com/macros/s/AKfycbzSZwglgjOBIygjnhU-_DKOu-f1YGo8THFmKh03uudCK_n46kImKTVExjRArj49c3DzEw/exec';

const labelClass = 'tw-mb-2 tw-font-display tw-text-sm tw-font-semibold tw-leading-tight tw-text-[#1a1b1e]';
const errorClass = 'tw-mt-1.5 tw-text-[13px] tw-leading-snug tw-text-[#e5484d]';

const MESSAGE_MAX = 1000;

const iconClass = 'tw-pointer-events-none tw-absolute tw-left-4 tw-text-[14px] tw-text-[#9aa0ab]';

const fieldClass = (hasError) =>
  [
    'tw-m-0 tw-box-border tw-w-full tw-rounded-[10px] tw-border tw-border-solid tw-py-3 tw-pl-11 tw-pr-4',
    'tw-font-text tw-text-[15px] tw-leading-normal tw-text-[#1a1b1e] tw-outline-none tw-transition',
    'tw-placeholder-[#9aa0ab] focus:tw-bg-white focus:tw-ring-4',
    hasError
      ? 'tw-border-[#e5484d] tw-bg-white focus:tw-border-[#e5484d] focus:tw-ring-[#e5484d]/15'
      : 'tw-border-[#e3e6ec] tw-bg-[#f8f9fb] hover:tw-border-[#cfd4dc] focus:tw-border-brand focus:tw-ring-brand/15',
  ].join(' ');

export default function Contact() {
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const [errorMsg, setErrorMsg] = useState('');
  const [errors, setErrors] = useState({});
  const [messageLength, setMessageLength] = useState(0);

  const validate = (form) => {
    const newErrors = {};
    if (!form.name.value.trim()) newErrors.name = 'Please enter your full name';
    const email = form.email.value.trim();
    if (!email) newErrors.email = 'Please enter your email address';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) newErrors.email = 'Please enter a valid email address';
    const phoneDigits = form.mobile.value.replace(/\D/g, '');
    if (form.mobile.value.trim() && (phoneDigits.length < 7 || phoneDigits.length > 15)) {
      newErrors.mobile = 'Please enter a valid phone number';
    }
    return newErrors;
  };

  const clearFieldError = (e) => {
    const { name } = e.target;
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const newErrors = validate(form);
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return;

    setStatus('sending');
    try {
      const res = await fetch(GOOGLE_SHEET_URL, { method: 'POST', body: new FormData(form) });
      const data = await res.json();
      if (data.result !== 'success') throw new Error(data.error || 'Submission failed');
      form.reset();
      setMessageLength(0);
      setStatus('sent');
    } catch (err) {
      console.error('Google Sheet error:', err);
      setErrorMsg(err.message);
      setStatus('error');
    }
  };

  return (
    <>
    <Header isActive={"contacts"} />
    <div id="content" className="site-content">
  <div className="page-header dtable text-center" style={{ backgroundImage: "url(resources/images/banner-.jpg)" }}>
    <div className="dcell">
      <div className="container">
        <h1 className="page-title">Contacts</h1>
        <ul id="breadcrumbs" className="breadcrumbs">
          <li><a href="#">Home</a></li>
          <li className="active">Contacts</li>
        </ul>
      </div>
    </div>
  </div>
  <section className="p-t110 z-index-1 section-contact tw-my-[30px] tw-pt-0">
    <div className="container my-8">
      <div className="row flex-row">
        <div className="col-md-6 col-xs-12 sm-m-b60">
          <div className="our-contact text-light">
            <div className="ot-heading text-light">
              <h6><span>contact details</span></h6>
              <h2 className="main-heading">Our Contacts</h2>
            </div>
            <p className="m-b45">
              Give us a call or drop by anytime, we endeavour to answer all enquiries within 24 hours on business days. We will be happy to answer your questions.
            </p>
            <div className="contact-info text-light m-b30">
              <i className="flaticon-world"></i>
              <div className="info-text">
                <h6>Our Address:</h6>
                <p>Shalimar swayam, bhangarh, Near, MR 10 Rd, Indore, Madhya Pradesh 453555</p>
              </div>
            </div>
            <div className="contact-info text-light m-b30">
              <i className="flaticon-note"></i>
              <div className="info-text">
                <h6>Our mailbox:</h6>
                <p><a href="mailto:info@proskillhub.com">info@humanixtechnologies.com</a></p>
              </div>
            </div>
            <div className="contact-info text-light">
              <i className="flaticon-viber"></i>
              <div className="info-text">
                <h6>Our phones:</h6>
                <p><a href="tel:8889332444">+91 8889332444</a></p>
                <p><a href="tel:6263070705">+91 6263070705</a></p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-xs-12 align-self-center">
          <div className="form-contact">
            <div className="ot-heading">
              <h6><span>GET IN TOUCH</span></h6>
              <h2 className="main-heading">Ready to Get Started?</h2>
            </div>
            {status === 'sent' ? (
              <div role="status" className="tw-mt-2.5 tw-rounded-[14px] tw-border tw-border-solid tw-border-[#b7e2c8] tw-bg-[#f1faf5] tw-px-8 tw-py-10 tw-text-center">
                <div className="tw-mx-auto tw-mb-4 tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#22a06b] tw-text-[22px] tw-text-white">
                  <i className="fa-solid fa-check"></i>
                </div>
                <h3 className="tw-mb-2 tw-font-display tw-text-[22px] tw-font-bold tw-text-[#1a1b1e]">Thank you for reaching out!</h3>
                <p className="tw-mx-auto tw-mb-6 tw-max-w-[380px] tw-text-[15px] tw-leading-relaxed tw-text-[#4b5563]">
                  Your message has been received. A member of our team will get back to you within 24 business hours.
                </p>
                <button type="button" onClick={() => setStatus('idle')}
                  className="tw-cursor-pointer tw-rounded-full tw-border tw-border-solid tw-border-[#d1d5db] tw-bg-white tw-px-5 tw-py-2.5 tw-text-[14px] tw-font-semibold tw-text-[#1a1b1e] tw-transition hover:tw-border-brand hover:tw-text-brand">
                  Send another message
                </button>
              </div>
            ) : (
            <form onSubmit={handleSubmit} onInput={clearFieldError} noValidate className="tw-mt-2.5">
              {/* Honeypot (spam trap) + source tag for the Google Sheet */}
              <input type="text" name="website" className="tw-absolute tw-left-[-9999px] tw-h-px tw-w-px tw-opacity-0" tabIndex="-1" autoComplete="off" aria-hidden="true" />
              <input type="hidden" name="source" value="Contact Page" />

              <p className="tw-mb-5 tw-mt-0 tw-text-[13px] tw-text-[#6b7280]">
                Fields marked with <span className="tw-text-brand">*</span> are required.
              </p>

              <div className="tw-grid tw-grid-cols-1 tw-gap-x-5 tw-gap-y-5 sm:tw-grid-cols-2">
                <div className="tw-flex tw-min-w-0 tw-flex-col">
                  <label htmlFor="name" className={labelClass}>Full name <span className="tw-text-brand">*</span></label>
                  <div className="tw-relative tw-flex tw-items-center">
                    <i className={`fa-solid fa-user ${iconClass}`} aria-hidden="true"></i>
                    <input type="text" name="name" id="name" placeholder="John Doe" autoComplete="name"
                      aria-invalid={!!errors.name} aria-describedby={errors.name ? 'name-error' : undefined}
                      className={`${fieldClass(errors.name)} tw-h-[50px]`} />
                  </div>
                  {errors.name && <span id="name-error" className={errorClass}><i className="fa-solid fa-circle-exclamation tw-mr-1"></i>{errors.name}</span>}
                </div>

                <div className="tw-flex tw-min-w-0 tw-flex-col">
                  <label htmlFor="company" className={labelClass}>Company</label>
                  <div className="tw-relative tw-flex tw-items-center">
                    <i className={`fa-solid fa-building ${iconClass}`} aria-hidden="true"></i>
                    <input type="text" name="company" id="company" placeholder="Your company name" autoComplete="organization"
                      className={`${fieldClass()} tw-h-[50px]`} />
                  </div>
                </div>

                <div className="tw-flex tw-min-w-0 tw-flex-col">
                  <label htmlFor="email" className={labelClass}>Work email <span className="tw-text-brand">*</span></label>
                  <div className="tw-relative tw-flex tw-items-center">
                    <i className={`fa-solid fa-envelope ${iconClass}`} aria-hidden="true"></i>
                    <input type="email" name="email" id="email" placeholder="you@company.com" autoComplete="email"
                      aria-invalid={!!errors.email} aria-describedby={errors.email ? 'email-error' : undefined}
                      className={`${fieldClass(errors.email)} tw-h-[50px]`} />
                  </div>
                  {errors.email && <span id="email-error" className={errorClass}><i className="fa-solid fa-circle-exclamation tw-mr-1"></i>{errors.email}</span>}
                </div>

                <div className="tw-flex tw-min-w-0 tw-flex-col">
                  <label htmlFor="mobile" className={labelClass}>Phone number</label>
                  <div className="tw-relative tw-flex tw-items-center">
                    <i className={`fa-solid fa-phone ${iconClass}`} aria-hidden="true"></i>
                    <input type="tel" name="mobile" id="mobile" placeholder="+91 98765 43210" inputMode="tel" maxLength="20" autoComplete="tel"
                      onChange={(e) => { e.target.value = e.target.value.replace(/[^\d+\-()\s]/g, ''); }}
                      aria-invalid={!!errors.mobile} aria-describedby={errors.mobile ? 'mobile-error' : undefined}
                      className={`${fieldClass(errors.mobile)} tw-h-[50px]`} />
                  </div>
                  {errors.mobile && <span id="mobile-error" className={errorClass}><i className="fa-solid fa-circle-exclamation tw-mr-1"></i>{errors.mobile}</span>}
                </div>

                <div className="tw-flex tw-min-w-0 tw-flex-col sm:tw-col-span-2">
                  <label htmlFor="budget" className={labelClass}>Project budget</label>
                  <div className="tw-relative tw-flex tw-items-center">
                    <i className={`fa-solid fa-wallet ${iconClass}`} aria-hidden="true"></i>
                    <select name="budget" id="budget" defaultValue=""
                      className={`${fieldClass()} tw-h-[50px] tw-cursor-pointer tw-appearance-none tw-pr-10`}>
                      <option value="" disabled>Select a range</option>
                      <option value="Under $2K">Under $2K</option>
                      <option value="$2K - $5K">$2K – $5K</option>
                      <option value="$5K - $10K">$5K – $10K</option>
                      <option value="$10K - $20K">$10K – $20K</option>
                      <option value="$20K - $30K">$20K – $30K</option>
                      <option value="More than $30K">More than $30K</option>
                      <option value="Not sure yet">Not sure yet</option>
                    </select>
                    <svg className="tw-pointer-events-none tw-absolute tw-right-4" width="12" height="8" viewBox="0 0 12 8" aria-hidden="true">
                      <path d="M1 1l5 5 5-5" stroke="#6b7280" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                </div>

                <div className="tw-flex tw-min-w-0 tw-flex-col sm:tw-col-span-2">
                  <label htmlFor="message" className={labelClass}>Project details</label>
                  <div className="tw-relative">
                    <i className={`fa-solid fa-message ${iconClass} tw-top-[17px]`} aria-hidden="true"></i>
                    <textarea name="message" id="message" rows="5" maxLength={MESSAGE_MAX}
                      placeholder="Tell us about your goals, timeline and the skills you need..."
                      onChange={(e) => setMessageLength(e.target.value.length)}
                      className={`${fieldClass()} tw-min-h-[140px] tw-resize-y`}></textarea>
                  </div>
                  <span className="tw-mt-1.5 tw-self-end tw-text-[12px] tw-text-[#9aa0ab]">{messageLength}/{MESSAGE_MAX}</span>
                </div>
              </div>

              {status === 'error' && (
                <div role="alert" className="tw-mt-5 tw-flex tw-gap-2.5 tw-rounded-[10px] tw-border tw-border-solid tw-border-[#f5c2c0] tw-bg-[#fdecec] tw-px-4 tw-py-3.5 tw-text-[14px] tw-leading-normal tw-text-[#b42318]">
                  <i className="fa-solid fa-circle-exclamation tw-mt-[3px]"></i>
                  <span>We couldn't send your message ({errorMsg}). Please try again or email us at <a href="mailto:info@humanixtechnologies.com" className="tw-font-semibold tw-text-[#b42318] tw-underline">info@humanixtechnologies.com</a>.</span>
                </div>
              )}

              <div className="tw-mt-6 tw-flex tw-flex-col tw-gap-4">
                <button type="submit" disabled={status === 'sending'}
                  className="octf-btn octf-btn-primary octf-btn-icon tw-m-0 tw-self-start disabled:tw-cursor-not-allowed disabled:tw-opacity-70 max-sm:tw-w-full max-sm:tw-justify-center">
                  {status === 'sending'
                    ? <><i className="fa-solid fa-spinner fa-spin tw-mr-2"></i>Sending...</>
                    : 'Send Message'} <i className="flaticon-right-arrow-1"></i>
                </button>
                {/* <p className="tw-m-0 tw-text-[13px] tw-leading-normal tw-text-[#6b7280]">
                  <i className="fa-solid fa-lock tw-mr-1.5 tw-text-[#9aa0ab]"></i>
                  Your information is kept confidential and never shared. We reply within 24 business hours.
                </p> */}
              </div>
            </form>
            )}
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div className="map">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3678.8129781636103!2d75.87456877540382!3d22.77232087934997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3962fd1c47d92e37%3A0x2f1b2d41363452e5!2sShalimar%20Swayam%20flat%20scheme!5e0!3m2!1sen!2sin!4v1735239592341!5m2!1sen!2sin"
        width="100%"
        height="500"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  </section>
</div>

    </>
  )
}
